import React from 'react'
import injectSheet from 'react-jss'
import styles from './main.styles.js'

const Main = ({ classes, children }) => {
  return <main className={classes.container}>{children}</main>
}

export default injectSheet(styles)(Main)
